import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { createBoat, useMyBoatPlaces, type BoatInput } from '../lib/boats';
import BoatForm from '../components/BoatForm';

const empty: BoatInput = {
  name: null,
  model: null,
  hullSerialNumber: null,
  modelYear: null,
  modelYearUnknown: false,
  engine: null,
  insuranceCompany: null,
  measurementCert: null,
  selfDeclaration: null,
};

export default function NewBoat() {
  const [params] = useSearchParams();
  const placeNumber = params.get('plats');
  const navigate = useNavigate();
  const { user } = useAuth();
  const { places, loading } = useMyBoatPlaces(user?.uid ?? null);

  if (!placeNumber) {
    return <p className="text-bad">Saknar ?plats= i URL.</p>;
  }
  if (loading) {
    return <p className="text-sm text-gray-500">Laddar…</p>;
  }
  const owns = places.some((p) => p.number === placeNumber);
  if (!owns) {
    return (
      <p className="text-bad">
        Du äger inte plats {placeNumber}. Om det är fel, kontakta styrelsen.
      </p>
    );
  }

  const tempId = `pending-${user!.uid}-${placeNumber}`;

  async function handleSave(values: BoatInput) {
    const newId = await createBoat(user!.uid, placeNumber!, values);
    navigate(`/mina-batar/${newId}`);
  }

  return (
    <section>
      <h1 className="text-2xl font-bold mb-4">Ny båt på plats {placeNumber}</h1>
      <BoatForm boatId={tempId} initial={empty} onSave={handleSave} />
    </section>
  );
}
